var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "base-nav--list-item", attrs: { href: _vm.event_uri } },
    [
      _c(
        "span",
        {
          staticClass: "d-flex align-items-center ",
          class: {
            "justify-content-between":
              _vm.direction !== "ltr" && _vm.direction !== "rtl",
            "justify-content-end": _vm.direction === "rtl",
            "justify-content-start": _vm.direction === "ltr"
          }
        },
        [
          _vm.direction == "ltr"
            ? _c(
                "BaseIcon",
                { staticClass: "mr-2", attrs: { cls: _vm.icon.cls } },
                [_vm._v(_vm._s(_vm.icon.content) + "\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c("span", { staticClass: "text-nowrap" }, [
            _vm._v(_vm._s(_vm.content_small) + " "),
            _c("span", { staticClass: "d-none d-md-inline" }, [
              _vm._v(_vm._s(_vm.content_large))
            ])
          ]),
          _vm._v(" "),
          _vm.direction == "rtl"
            ? _c(
                "BaseIcon",
                { staticClass: "ml-2", attrs: { cls: _vm.icon.cls } },
                [_vm._v(_vm._s(_vm.icon.content) + "\n        ")]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bde8788", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bde8788","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/base/BaseNavListItem.vue
// module id = 461
// module chunks = 0